import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Assets/css/vendor.min.css";
import "./Assets/css/style.css";
import "./Assets/css/style2.css";
import "./Assets/css/Dashboard.css";
import "./Assets/css/media.css";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setUserData } from "./Redux/ActionCreater";
// import UserRegister from './Component/Register/UserRegister';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import PrivateRoute from "./Partial/PrivateRoute";
import NonAuthRoute from "./Partial/NonAuthRoute";
import Loader from "./Partial/Loader";
import Profile from "./Component/Dashboard/Profile";

let Header = React.lazy(() => import("./Partial/Header"));
let Footer = React.lazy(() => import("./Partial/Footer"));
let Login = React.lazy(() => import("./Component/Login/UserLogin"));
let CMS = React.lazy(() => import("./Component/CMS/CMS"));
let ForgetPassword = React.lazy(() =>
  import("./Component/ForgetPassword/ForgetPassword")
);
let ResetPassword = React.lazy(() =>
  import("./Component/ResetPassword/ResetPassword")
);
let JobDetails = React.lazy(() => import("./Component/Login/JobDetails"));
let JobDetailsView = React.lazy(() =>
  import("./Component/Login/JobDetailsView")
);
let Registration = React.lazy(() => import("./Component/Login/Registration"));
let Activation = React.lazy(() => import("./Component/Login/Activation"));
// let Dashboard = React.lazy(() => import("./Component/Dashboard/Profile"));
let EditProfile = React.lazy(() => import("./Component/Profile/Profile"));
let AppliedJob = React.lazy(() =>
  import("./Component/Dashboard/AppliedJob/AppliedJob")
);
let ChangePassword = React.lazy(() =>
  import("./Component/Dashboard/ChangePassword/ChangePassword")
);
let CurrentOpening = React.lazy(() =>
  import("./Component/Dashboard/CurrentOpening/CurrentOpening")
);
let APIStep1 = React.lazy(() => import("./Component/Dashboard/API/APIStep1"));
let APIStep2 = React.lazy(() => import("./Component/Dashboard/API/APIStep2"));
let APIStep3 = React.lazy(() => import("./Component/Dashboard/API/APIStep3"));
let CurrentOpeningDetails = React.lazy(() =>
  import("./Component/Dashboard/CurrentOpening/Details")
);

function App() {
  let dispatch = useDispatch();
  useEffect(() => {
    localStorage.getItem("log_in_data") &&
      dispatch(setUserData(JSON.parse(localStorage.getItem("log_in_data"))));
  });
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Header />
        <Routes>
          <Route
            exact
            path="/login"
            element={
              <NonAuthRoute>
                <React.Suspense fallback={<Loader />}>
                  <Login />
                </React.Suspense>
              </NonAuthRoute>
            }
          />
          <Route
            exact
            path="/forget-password"
            element={
              <React.Suspense fallback={<Loader />}>
                <ForgetPassword />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/reset-password/:token"
            element={
              <React.Suspense fallback={<Loader />}>
                <ResetPassword />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/activation-page/:token"
            element={
              <React.Suspense fallback={<Loader />}>
                <Activation />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/registration"
            element={
              <React.Suspense fallback={<Loader />}>
                <Registration />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/job-details"
            element={
              <React.Suspense fallback={<Loader />}>
                <JobDetails />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/job-details-view/:id"
            element={
              <React.Suspense fallback={<Loader />}>
                <JobDetailsView />
              </React.Suspense>
            }
          />
          <Route
            exact
            path="/dashboard"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <Profile />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/edit-profile"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <EditProfile />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/applied-job"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <AppliedJob />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/change-password"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <ChangePassword />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/current-opening"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <CurrentOpening />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/academic-performance-indicator-step-1"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <APIStep1 />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/academic-performance-indicator-step-2"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <APIStep2 />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/academic-performance-indicator-step-3"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <APIStep3 />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/current-opening-details/:id"
            element={
              <PrivateRoute>
                <React.Suspense fallback={<Loader />}>
                  <CurrentOpeningDetails />
                </React.Suspense>
              </PrivateRoute>
            }
          />
          <Route
            exact
            path="/:slug"
            element={
              <NonAuthRoute>
                <React.Suspense fallback={<Loader />}>
                  <CMS />
                </React.Suspense>
              </NonAuthRoute>
            }
          />
          <Route path="/*" element={<Navigate to="/login" />} />
        </Routes>
        <Footer />
      </BrowserRouter>

      <ToastContainer
        position="bottom-center"
        style={{ zIndex: "999999999" }}
      />
    </div>
  );
}

export default App;
